import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const FIVE_MINUTE = 5 * 60 * 1000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTE,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const RootElement = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default RootElement;
